import React, { useState } from 'react';
import { Dialog, DialogContent } from '@mui/material';
import SchedulerTab from './SchedulerTab';
import IntegrationTab from './IntegrationTab';
import EmailTab from './EmailTab';

const SuiteSettingsModal = ({ open, onClose, suite }) => {
  const [activeTab, setActiveTab] = useState('scheduler');

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        style: {
          fontFamily: 'inherit',
          borderRadius: '8px',
          maxWidth: '1000px',
        },
      }}
    >
      <div className="font-apple">
        <div className="border-b border-gray-200 px-6 py-4">
          <h2 className="text-lg font-semibold">
            Suite Settings - {suite?.testSuiteName}
          </h2>
        </div>
        <DialogContent style={{ padding: '24px' }}>
          <div className="border-b border-gray-200 pb-4 mb-6 flex items-center gap-2">
            <button
              onClick={() => setActiveTab('scheduler')}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer ${
                activeTab === 'scheduler'
                  ? 'bg-blue-50 text-blue-600 border border-blue-100'
                  : 'text-gray-600 hover:bg-gray-50 border border-transparent'
              }`}
            >
              Scheduler
            </button>
            <button
              onClick={() => setActiveTab('integration')}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer ${
                activeTab === 'integration'
                  ? 'bg-blue-50 text-blue-600 border border-blue-100'
                  : 'text-gray-600 hover:bg-gray-50 border border-transparent'
              }`}
            >
              Integration
            </button>
            <button
              onClick={() => setActiveTab('email')}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer ${
                activeTab === 'email'
                  ? 'bg-blue-50 text-blue-600 border border-blue-100'
                  : 'text-gray-600 hover:bg-gray-50 border border-transparent'
              }`}
            >
              Email
            </button>
          </div>
          <div>
            {activeTab === 'scheduler' && <SchedulerTab suite={suite} />}
            {activeTab === 'integration' && <IntegrationTab suite={suite} />}
            {activeTab === 'email' && <EmailTab suite={suite} />}
          </div>
        </DialogContent>
      </div>
    </Dialog>
  );
};

export default SuiteSettingsModal;
